'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getScreenType = undefined;

var _screenSize = require('../constants/screen-size');

var _screenSize2 = _interopRequireDefault(_screenSize);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getScreenType = exports.getScreenType = function getScreenType(width) {
  if (width <= _screenSize2.default.smallScreenMaxWidth) {
    return 'MOBILE';
  } else if (width >= _screenSize2.default.mediumScreenMinWidth && width <= _screenSize2.default.mediumScreenMaxWidth) {
    return 'TABLET';
  } else {
    return 'DESKTOP';
  }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/utils/get-screen-type.js
 ** module id = 846
 ** module chunks = 0
 **/